import React from 'react';
import PropTypes from 'prop-types';

import StyledComponent from '~/components/Styled/Styled';
import PlayerHeadshot from '~/components/PlayerHeadshot/PlayerHeadshot';
// import Link from '~/components/Link/Link';
import css from './TeamRosterPlayer.scss';

class TeamRosterPlayer extends React.PureComponent {
  render() {
    const { player } = this.props;

    return (
      <span key={`player-${player.id}`}>
        <div className={`${css.player} col-md-6`}>
          <div className={css.headshot}>
            <PlayerHeadshot player={player} size="small" />
          </div>
          <div className={css.name}>{player.full_name}</div>
          <div className={css.number}>{player.number}</div>
          <div className={css.position}>{player.position_abbreviation}</div>
        </div>
      </span>
    );
  }
}

TeamRosterPlayer.propTypes = {
  player: PropTypes.object.isRequired,
};

export default StyledComponent(TeamRosterPlayer, [css]);
